<script type="ts">
  export let handler: () => void;
  export let title: string = "";
  export let iconOnTheLeft: boolean = true;
  export let disabled: boolean = false;

  /**
   * Handle keyboard events
   * @param event - The keyboard event
   * @returns void
  */
  const onKeyDown = (event: KeyboardEvent): void => {
    switch (event.key) {
      case "Enter":
        focusCurrentButton();
        break;

      default:
        // Allow default behavior for other keys
        return;
    }

    // Prevent default behavior only for relevant keys
    event.preventDefault();
  };

  /**
   * Focus the current button
   * @returns void
  */
  const focusCurrentButton = () => {
    const button = document.getElementById($$props.id);
    if (button?.title === "Add content" || button?.title === "Edit content") {
      button?.focus();
    } else {
      button?.click();
    }
  };
</script>

<button
  type="button"
  data-testid="button_test_id"
  {title}
  on:click={() => !disabled && handler()}
  style={iconOnTheLeft ? "--icon-order: 0" : ""}
  id={$$props.id}
  class:disabled
  tabindex="0"
  on:keydown={onKeyDown}
>
  {#if $$slots.text}
    <div class="text">
      <slot name="text" />
    </div>
  {/if}
  {#if $$slots.icon}
    <div class="icon">
      <slot name="icon" />
    </div>
  {/if}
</button>

<style lang="scss">
  button {
    padding: 0.75rem 1.5rem;

    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;

    border-radius: 0.5rem;
    cursor: pointer;
    font-size: 1rem;
    line-height: 1;

    background-color: var(--color-secondary);
    color: var(--color-white);

    .text {
      height: 1rem;
      white-space: nowrap;
      order: 1;
      user-select: none;
    }

    .icon {
      order: var(--icon-order, 1);
    }
  }
</style>
